<div class="text-center">
    <h3 style="color: red;">{{errorMessage}}</h3>
    <h3>{{deleteConfirmationParam.dialogTitle}}</h3>
    <h5>{{deleteConfirmationParam.dialogMessage}}</h5>
    <button (click)="handleConfirmButtonClick()" class="btn btn-danger" style="margin-right:10px;">Confirm</button>
    <button (click)="handleCanceButtonClick()" class="btn btn-warning">Cancel</button>
</div>
